export default __webpack_public_path__ + "static/banner-PT-web-45c7ec22eca3982ee67edde771f9f543.png";